import ActContext from 'hooks/ActContext'
import { useContext } from 'react'

export default function useAct() {
  const { actions } = useContext(ActContext)

  return actions
}

